// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import type {ProductSlice, RootState } from "redux/types";
import { MyProduct } from "interfaces/productPage/product";

// Initial State
export const initialState: ProductSlice = {
    product: null
};

// Slice
export const productSlice = createSlice({
    name: "PRODUCT",
    initialState,
    reducers: {
        setProduct: (state, action: PayloadAction<MyProduct>) => {
            return { ...state, product: action.payload };
        }
        //INSERT CLEAR METHOD
    }
});

// Actions
export const { setProduct} = productSlice.actions;

// Selector
export const productSelector = (state: RootState): MyProduct | null => state.product.product;

// Reducer
export default productSlice.reducer;
